import { classnames } from 'tailwindcss-classnames';
import ArrowCollapse from 'components/helpers/SvgIcon/icons/arrow-collape';
import ArroweExpand from 'components/helpers/SvgIcon/icons/arrow-expand';
import { ReactMobileTabsProps } from './_types';

export const ReactMobileTabsLayout = ({
  toggleCategory,
  isOpenMobile,
  tabs,
}: ReactMobileTabsProps) => {
  const categories = tabs;
  const noCategories = !categories || categories.length === 0;
  const arrowClassNames = classnames(`text-blue-morning`, `w-[20px]`, `h-[10px]`);

  return (
    <>
      <ul data-nmdp-tabstrip="tabstrip" className={classnames({ hidden: noCategories })}>
        {tabs.map((item, index) => (
          <li
            key={item.name}
            className={classnames(`border-t`, `border-solid`, `border-gray-midGray`, `py-[24px]`)}
          >
            <div>
              <button
                type="button"
                data-nmdp-tab={index}
                className={classnames(
                  `font-bold`,
                  `flex`,
                  `text-left`,
                  `cursor-pointer`,
                  `w-full`,
                  `items-center`
                )}
                onClick={() => toggleCategory(index)} // Toggle the category when the button is clicked
              >
                <span className={classnames(`pr-2.5`)}>
                  {isOpenMobile[index] ? (
                    <ArroweExpand className={arrowClassNames} />
                  ) : (
                    <ArrowCollapse className={arrowClassNames} />
                  )}
                </span>
                <div>
                  <h3 className={classnames(`text-black`, `font-bold`, `leading-7`)}>
                    {item?.name}
                  </h3>
                </div>
              </button>
            </div>
            <div className={classnames(`pl-[30px]`, `pr-[20px]`)}>
              <div
                className={classnames({
                  ['my-[30px]']: isOpenMobile[index],
                  ['p-0']: !isOpenMobile[index],
                  ['hidden']: !isOpenMobile[index],
                })}
              >
                <div key={item.name} data-nmdp-tab={index}>
                  {item.component}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};
